const config = {
    env: "prelive",
    timeUpdate: 10 * 60 * 24 * 1 * 1000,
    API : {
        uri: "https://backoffice.chateaudechimay.be"
    }
}

export default config;